import application_settings from '../applicationSettings';
import Event from './Event';

class UserResetPassword extends Event {
    eventName = 'oms_userResetPassword';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for reset password
     * 
     * @param {string} data.password -  password given for customer
     * @param {string} data.confirm_password -  confirm_password given for customer
     * @param {string} data.password_token -  password_token given for customer
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let password = data.password;
        let confirmPassword = data.confirm_password;
        let passwordToken = data.password_token;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (password && confirmPassword && passwordToken) {

            // request data
            data.endPoint = application_settings.endPoints.userResetPassword;
            data.method = 'POST';
            data.canUsePublicAuth = false;
            data.data = {
                client_id: clientId,
                password: password,
                confirm_password: confirmPassword,
                password_token: passwordToken
            };
        
            // send request
            this.sendRequest(data, function (response) {
              if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "password & confirm_password & password_token is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }


}

export default UserResetPassword;